import React from "react";
import { fmtMoney } from "../lib/api";

/**
 * Pro-rata allocation table shown next to the bulk-buy inputs.
 * Pure presentational component — no fetch logic of its own.
 */
export default function BulkAllocationTable({ allocation, minUsd, overPool }) {
  if (!allocation) {
    return (
      <div className="border border-line bg-bg p-6 text-xs text-ink2 font-mono">
        Enter at least {fmtMoney(minUsd, "USD")} (or its equivalent) to see the pro-rata allocation across registered ISINs.
      </div>
    );
  }
  return (
    <>
      <div className="border border-line">
        <div className="bg-bg px-4 py-3 border-b border-line grid grid-cols-3 text-[11px] font-mono">
          <Stat label="Fulfilled (USD)" value={fmtMoney(allocation.fulfilled_usd, "USD")} />
          <Stat label="Total tons" value={`${Math.round(allocation.total_tons).toLocaleString()} t`} />
          <Stat label="Pending desk (USD)" value={fmtMoney(allocation.unfulfilled_usd, "USD")} tone={allocation.unfulfilled_usd > 0 ? "amber" : "ink"} />
        </div>
        <div className="max-h-80 overflow-y-auto" data-testid="bulk-allocation-table">
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-line text-left">
                <Th>Project</Th><Th>Region</Th><Th>Tons</Th><Th>USD</Th><Th>%</Th>
              </tr>
            </thead>
            <tbody>
              {allocation.items.map((it) => (
                <tr key={it.project_id} className="border-b border-line/60">
                  <Td><span className="font-serif">{it.project_name}</span></Td>
                  <Td className="text-ink2">{it.region || "—"}</Td>
                  <Td className="mono-num">{Math.round(it.tons).toLocaleString()}</Td>
                  <Td className="mono-num">{fmtMoney(it.usd, "USD")}</Td>
                  <Td className="mono-num">{it.weight_pct.toFixed(1)}%</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {overPool && (
        <div className="mt-3 text-[11px] font-mono text-amber-700 bg-amber-50 border border-amber-200 px-3 py-2">
          Order exceeds the auto-allocable pool. The trading desk will manually place the residual from the admin reserve.
        </div>
      )}
    </>
  );
}

function Stat({ label, value, tone = "ink" }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wider text-ink2">{label}</div>
      <div className={`mono-num text-sm mt-0.5 ${tone === "amber" ? "text-amber-700" : "text-ink"}`}>{value}</div>
    </div>
  );
}

function Th({ children }) { return <th className="px-3 py-2 text-[10px] font-sans tracking-[0.15em] uppercase text-ink2">{children}</th>; }
function Td({ children, className = "" }) { return <td className={`px-3 py-2 ${className}`}>{children}</td>; }
